module.exports = __webpack_public_path__ + "static/media/DEP.34d2daba.png";